import { render } from "./psp-limit.vue?vue&type=template&id=5f706e59&ts=true"
import script from "./psp-limit.ts?vue&type=script&lang=ts"
export * from "./psp-limit.ts?vue&type=script&lang=ts"

import "./psp-limit.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__